<template>
  <div>
    <div :style="`min-height:${minHeight};`" class="position-relative">
      <div :class="sideClass" class="group-title">
        <span>{{ headerText }}</span>
      </div>
      <draggable
        v-if="disabled ? value && value.length : true"
        @end="draggableEnd"
        :disabled="disabled"
        draggable=".item"
        handle=".mover"
        :animation="500"
        forceFallback
        class="d-flex flex-wrap"
      >
        <el-upload
          v-if="!disabled"
          class="image-item filter"
          action="/oss/ossUploadReturnUrlAndFileId"
          :file-list="listImage"
          :show-file-list="false"
          :auto-upload="false"
          multiple
          accept=".jpeg,.jpg,.png,.gif"
          :on-change="onImageChange"
        >
          <div slot="trigger" class="el-upload el-upload--picture-card">
            <i class="el-icon-plus"></i
            ><input type="file" name="file" class="el-upload__input" />
          </div>
        </el-upload>
        <div
          v-for="(item, index) in imageViews"
          :key="index"
          class="image-item mover item"
        >
          <el-tooltip
            placement="top"
            :disabled="disabled"
            :content="'鼠标点击拖动'"
          >
            <div class="image-box">
              <el-image
                style="width: 100%; height: 100%"
                fit="scale-down"
                :src="item"
                :preview-src-list="imageViews"
              ></el-image>
              <div
                class="shadow d-flex align-items-center justify-content-center"
              >
                <div>
                  <span @click="onImagePreview(index)" class="mr-2">
                    <i class="el-icon-zoom-in"></i
                  ></span>
                  <span @click="onImageRemove(index)" v-if="!disabled">
                    <i class="el-icon-delete"></i
                  ></span>
                </div>
              </div>
            </div>
          </el-tooltip>
        </div>
      </draggable>

      <div
        class="position-absolute d-flex justify-content-center align-items-center"
        style="text-align: center;top: 0;right: 0;left: 0;bottom: 0;
"
        v-if="disabled && (!listImage || !listImage.length)"
      >
        <div>
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </div>
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img v-for="(item, index) in imageViews" :src="item" :key="index" />
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  components: { draggable },
  props: {
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    headerText: { type: String, default: '' },
    sideClass: { type: String, default: '' },
    minHeight: { type: String, default: '450px' },
  },
  data() {
    return {
      listImage: [],
    }
  },
  computed: {
    imageViews() {
      return (this.listImage || []).map((file) => {
        if (file.raw) {
          return URL.createObjectURL(file.raw)
        }
        if (file.originImageUrl) {
          return file.originImageUrl
        }
        return '/image/static/img/nopic.jpg'
      })
    },
  },
  watch: {
    value: {
      handler(val) {
        this.listImage = val || []
      },
      immediate: true,
    },
  },
  methods: {
    onImageChange(file, fileList) {
      this.changeValue(fileList)
    },
    onImagePreview(index) {
      if (this.listImage.length) {
        this.viewer = this.$el.querySelector('.imagesViewer').$viewer
        this.viewer.view(index)
        this.viewer.show()
      }
    },
    onImageRemove(index) {
      const listFile = this.listImage.concat()
      listFile.splice(index, 1)
      this.changeValue(listFile)
    },
    draggableEnd({ newIndex, oldIndex }) {
      if (!newIndex || !oldIndex || newIndex === oldIndex) return

      const _newIndex = newIndex - 1
      const _oldIndex = oldIndex - 1
      let listFile = this.listImage.concat()
      const oldEl = Object.assign({}, listFile[_oldIndex])

      if (_newIndex < _oldIndex) {
        for (let i = _oldIndex; i > _newIndex; i--) {
          listFile[i] = listFile[i - 1]
        }
      } else {
        for (let i = _oldIndex; i < _newIndex; i++) {
          listFile[i] = listFile[i + 1]
        }
      }
      listFile[_newIndex] = oldEl

      this.changeValue(listFile)
    },
    changeValue(value) {
      this.$emit('input', [])
      this.$emit('update:value', [])
      setTimeout(() => {
        this.$emit('input', value)
        this.$emit('update:value', value)
      }, 0)
    },
    async getImagesData() {
      return await this.listImage
    },

    // 外部上传可以参考以下代码

    // async fileHander(files) {
    //   const readyFiles = this.filterReadyFiles(files)
    //   const uploadFils = await this.uploadImages(readyFiles)
    //   return this.mergeFiles(files, uploadFils)
    // },
    // mergeFiles(allFils, uploadFils) {
    //   for (let i in uploadFils) {
    //     for (let j in allFils) {
    //       if (uploadFils[i].uid === allFils[j].uid) {
    //         allFils[j] = uploadFils[i]
    //       }
    //     }
    //   }
    //   return allFils
    // },
    // filterReadyFiles(listFiles) {
    //   return listFiles.filter((file) => {
    //     if (file.status && 'ready' === file.status) return file
    //   })
    // },
    // uploadImages(readyFiles) {
    //   if (!readyFiles || !readyFiles.length) {
    //     return Promise.resolve([])
    //   }
    //   const uploadTask = readyFiles.map((file) => {
    //     return this.$api.SYS_UPLOAD(file.raw).then((res) => ({
    //       originImageCode: res.body.fileId,
    //       originImageUrl: res.body.url,
    //       originImageSpec: file.raw.type,
    //       thumbImageCode: res.body.thumbnailFileId,
    //       thumbImageUrl: res.body.thumbnailUrl,
    //       uid: file.uid,
    //     }))
    //   })
    //   return Promise.all(uploadTask)
    // },
  },
}
</script>
<style lang="scss" scoped>
.image-box {
  width: 148px;
  height: 148px;
  line-height: 148px;
  position: relative;
  background-color: #fbfdff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}
.shadow {
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}

.image-item {
  margin-right: 8px;
  margin-bottom: 8px;
}
</style>
